export function percentCalc(
  previous: number | string,
  current: number | string
) {
  let previous_price = Number(previous);
  let current_price = Number(current);
  let result = (current_price * 100) / previous_price;

  return 100 - Math.floor(result);
}
